import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

export default function RouteWrapper({ isPrivate, children }) {
  const signed = !!localStorage.getItem('_t');

  if (isPrivate && !signed) {
    return <Navigate to="/" />;
  }

  if (!isPrivate && signed) {
    return <Navigate to="/dashboard/assistants" />;
  }

  return children;
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};
